import React, { Component } from 'react';

import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col
} from 'reactstrap';

import './App.css';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: '',
      password: '',
      validate: {
        emailState: '',
      },
    };

    this.onUserIdChanged = this.onUserIdChanged.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  onUserIdChanged(e) {
    this.setState({
      userId: e.target.value
    });
  }

  submitForm(e) {
    e.preventDefault();
    console.log(`Email: ${this.state.userId}`);
  }

  render() {
    return (
      <div className="content">
        <Container className="login">
          <Row>
            <Col>
              <h1>ObjGen - Live Code Generation for the Web</h1>
            </Col>
          </Row>
          <br />
          <Row>
            <Col className="features-col features-summary" sm="12" md="5">
              <Form onSubmit={this.submitForm}>
                <h2>Log In to ObjGen</h2>
                <FormGroup>
                  <Label for="userId">Username or Email address</Label>
                  <Input type="text" name="userId" id="userId"
                         value={this.state.userId}
                         onChange={this.onUserIdChanged} />
                </FormGroup>
                <FormGroup>
                  <Label for="password">Password</Label>
                  <Input type="password" name="password" id="password" />
                </FormGroup>
                <FormGroup>
                  <Row>
                    <Col md="6" sm="12">
                      <Button color="primary" block className="mt-2">Log In</Button>
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <a href="/forgot">Forgot password?</a>
                </FormGroup>
              </Form>
            </Col>
            <Col className="features-col" sm="12" md="6 offset-md-1">
              <Card>
                <CardHeader><h2>Features & Benefits</h2></CardHeader>
                <CardBody>
                  <ul>
                    <li>Easy to use</li>
                    <li>Code generates in real time as you type</li>
                    <li>Models are defined using a simple text based syntax</li>
                    <li>Use the Enter and Tab keys to define complex models and structures</li>
                    <li>Learn by example as code generates based on your model definition</li>
                    <li>ObjGen is an excellent addition to your tool box for quickly building demos and prototyping</li>
                    <li>One click clipboard copy support of the generated code</li>
                  </ul>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Login;
